<template>
  <div class='epss-score' :style="style">
    {{value}} %
  </div>
</template>

<script>
import { hexToRgba } from '@/utils/colorUtils';

export default {
  name: 'EpssScore',
  props: {
    value: {
      type: Number,
      required: true,
    },
  },
  computed: {
    colorsForLevels() {
      const epss = this.value;
      if (epss < 0) {
        return { color: '#4D9FEB' };
      }
      if (epss > 90) {
        return { color: '#DF399F' };
      }
      if (epss <= 90 && epss > 70) {
        return { color: '#FF7F00' };
      }
      if (epss <= 70 && epss > 30) {
        return { color: '#2459D5' };
      }
      return { color: '#2BAF69' };
    },
    style() {
      return {
        backgroundColor: hexToRgba(this.colorsForLevels.color, 0.1),
        ...this.colorsForLevels,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.epss-score {
  color: var(--text-secondary);
  background-color: var(--bg-tertiary);
  border-radius: $radius-md;
  text-transform: capitalize;
  align-items: center;
  display: flex;
  font-family: $font-family-semibold;
  font-size: $font-size-sm;
  letter-spacing: 0;
  line-height: rem(17);
  justify-content: center;
  padding: rem(2) $space-1;
  min-width: rem(65);
  margin-left: rem(-15);
}
</style>
